import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { ConfigurationServices } from '../../../configuration/services';
import * as firebase from 'firebase';


/**
 * Generated class for the KitchenTotalOrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kitchen-total-orders',
  templateUrl: 'kitchen-total-orders.html',
})
export class KitchenTotalOrdersPage {

  public chartData: any;
  public chartLabels: any;
  public chartCheck: any;
  public firestore: any;

  result: any;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'DATE', name: this.translate.instant('general-fecha') },
    { prop: 'chef', name: this.translate.instant('general-cocinero') },
    { prop: 'total', name: this.translate.instant('general-n-elementos-hechos-en-cocina') },
    { prop: 'TYPE', name: this.translate.instant('general-tipo') },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public configurationServices: ConfigurationServices,
  ) {
    this.firestore = firebase.firestore();

    this.getAnalyticsData();
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/kitchen_total_orders', params, {})
      .subscribe(async response => {
        //total
        this.result = response['total'];
        //grafica

        this.chartData = response['data_kitchen']['data']; //total's
        this.chartLabels = response['data_kitchen']['labels'];//Dates


        var response_array = response['list'];
        //traducir los tipos de pedidos
        for (let i = 0; i < response_array.length; i++) {
          if (response_array[i].TYPE == 'TAKEAWAY') {
            response_array[i].TYPE = this.translate.instant('general-takeaway');
          } else {
            response_array[i].TYPE = this.translate.instant('general-mesa');
          }
        }

        //listado
        this.rows = response['list'];
        this.temp = response['list'];

        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const formatedData = this.rows.map(x => ({
      'chef': x.chef,
      'order elements': x.total,
      'date': x.DATE,
      'type': x.TYPE
    }));
    const params = new HttpParams()
      .set('data', JSON.stringify(formatedData))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({ 'Total': this.result }));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/kitchen-total-orders/kitchen-total-orders.ts